module.exports = __webpack_public_path__ + "img/mark3.7c7b1a5b.png";